module.exports = __webpack_public_path__ + "media/images/marketing/app_video_thumbnail3-396bb933ee03917171f2c31c6548894c6a0bafeb8fb7effdec8f3469fbafe160.jpg";